module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIkAAAADCAYAAACnDyx3AAAAYklEQVQ4T2NcuHBhPQMSYGJigvMIsQnJgwyCqUFWS6o4KfbgMpsaZtDS7MHsPsb58+fXE3IgMRFMyAzkAMbFJtcMYtxHjQgm133E+Hcwuw9nIhnsAT/Y3UdqwhgsiQRbuAIAOeIKeDfUBi0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title_line01.png
// module id = K6gO
// module chunks = 1